import { features } from 'constants/featureFlags';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import {
  getConversationsUrl,
  goToConversation,
  goToConversations,
  goToHome,
  pathnames,
} from 'utils/routerHelpers';
import { isAdmin } from 'utils/userHelpers';

import React from 'react';

import { ChatsCircle, UsersThree } from '@thinkific/chalk/react-icons';
import { GlobalNav } from '@thinkific/chalk/recipes/GlobalNav';

import { useCommunityContext } from 'components/CommunityContext';
import { useChatContext } from 'components/new/chat/providers/ChatProvider/ChatProvider';
import { useGlobalState } from 'components/new/providers/GlobalStateProvider';

import { SiteLogo } from './SiteLogo';
import * as css from './SiteNav.css';

export const SiteNav = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { featureFlags, currentUser, community, inLearnerHub } = useCommunityContext();
  const { isDirectMessagingEnabled, hasUnreadMessages, conversations } = useChatContext();
  const { lastConversationId } = useGlobalState();
  const showDirectMessaging =
    featureFlags[features.DIRECT_MESSAGING] && (isAdmin(currentUser) || isDirectMessagingEnabled);

  if (inLearnerHub) return <></>;

  const menuItems = [
    {
      id: 'communities',
      dataUserPilotId: 'site-nav-community',
      icon: UsersThree,
      label: t('site-nav_communities', 'Community'),
      href: `/communities/${community.id}/`,
      onClick: () => goToHome(router, community.id),
    },
    ...(showDirectMessaging
      ? [
          {
            id: 'conversations',
            dataUserPilotId: 'site-nav-dm',
            icon: ChatsCircle,
            label: t('pages-conversations_title', 'DMs'),
            notificationDot: hasUnreadMessages,
            href: getConversationsUrl(community.id),
            onClick: () => {
              const conversationId = lastConversationId || conversations[0]?.id || null;
              if (isDirectMessagingEnabled && conversationId) {
                goToConversation(router, community.id, conversationId);
              } else {
                goToConversations(router, community.id);
              }
            },
          },
        ]
      : []),
  ];

  return (
    <nav className={css.sidebar}>
      <div className={css.container} data-qa="sidebar">
        <SiteLogo />

        <GlobalNav
          currentItemId={
            Object.values(pathnames.directMessaging).includes(router.pathname)
              ? 'conversations'
              : 'communities'
          }
          direction="vertical"
          items={menuItems}
        />
      </div>
    </nav>
  );
};

export default SiteNav;
